export default "__VITE_ASSET__DlYgSJqE__"